import { createContext } from 'react';

export const AppContextDefaults = {
    is_initialized: false,
    visitor: null,
    components: {},
    home: {},
    context: {},
    _contextSetup: false,
    setContext: (newContext) => {}, // Placeholder, overridden in PelaajatComApp with setState
    updateContext: (key, value) => {}, // -"-
};
export const AppContext = createContext(AppContextDefaults);
